<qa-button
  [isRaisedButton]="config.raised"
  [disabled]="config.disableIf && config.disableIf(state)"
  [icon]="config.icon"
  (submitted)="config.handler(state, $event)"
  [label]="config.text"
  [buttonClass]="config.class"
  type="button"
  data-cy="actionButton"
></qa-button>
